module.exports = ".product {\r\n    border-bottom: dotted gray 1px;\r\n}\r\n\r\n.prodimage {\r\n    margin: 12px 12px;\r\n}"